<template>
  <!-- Modal para actualizar requerimiento -->
  <div id="contenedor">
    <v-dialog v-model="dialogActualizar" width="700">
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white"
            ><v-icon color="white" class="me-3">mdi-google-assistant</v-icon
            >Actualizar Requerimiento</span
          >
        </v-card-title>
        <!-- componente del modal para agregar y actualizar -->
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <h3 class="mt-5">
                <v-icon class="me-3">mdi-map-marker-radius</v-icon
                >{{ itemToEdit.cc_nombre_area }}
              </h3>
              <v-flex xs12 sm12 md12 class="mt-5">
                <v-text-field
                  v-model="itemToEdit.cc_nombre_requerimiento"
                  label="Nombre del requerimiento"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-select
                  item-value="name"
                  item-text="name"
                  :items="prioridades"
                  label="Prioridad"
                  v-model="itemToEdit.cc_prioridad_requerimiento"
                ></v-select>
              </v-flex>
              <v-flex xs4 s4 m4 class="mt-5">
                <v-text-field
                  v-model="itemToEdit.dias"
                  label="Dias"
                  type="number"
                ></v-text-field>
              </v-flex>
              <v-flex xs4 s4 m4 class="mt-5">
                <v-text-field
                  v-model="itemToEdit.horas"
                  label="Horas"
                  type="number"
                ></v-text-field>
              </v-flex>
              <v-flex xs4 s4 m4 class="mt-5">
                <v-text-field
                  v-model="itemToEdit.minutos"
                  label="Minutos"
                  type="number"
                ></v-text-field>
              </v-flex>
              <!--  -->
            </v-layout>
          </v-container>
        </v-card-text>
        <!-- botones para cancelar y agregregar y validacion de campos vacios -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#1D3C7F" dark @click="closeDialogActualizar()"
            >Cancelar</v-btn
          >
          <v-btn color="#1D3C7F" dark @click="handleUpdate">Actualizar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout row wrap="">
      <v-flex xs12 sm12 md12>
        <v-card class="table" elevation="4">
          <v-toolbar flat elevation="4">
            <v-card class="icon">
              <v-icon
                style="margin-left: 30px; margin-top: 25px"
                color="white"
                x-large=""
                >mdi-google-assistant</v-icon
              >
            </v-card>
            <div class="usuario"></div>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="700px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn dark class="botonplus" v-on="on"
                  ><v-icon color="white">mdi-plus-thick</v-icon></v-btn
                >
              </template>
              <v-card>
                <v-card-title class="nav">
                  <span class="headline" style="color: white"
                    ><v-icon color="white">mdi-google-assistant</v-icon>
                    {{ formTitle }}</span
                  >
                </v-card-title>
                <!-- componente del modal para agregar y actualizar -->
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm12 md12>
                        <v-text-field
                          v-model="editedItem.nombre"
                          label="Requerimiento"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-autocomplete
                          item-value="cc_id_area"
                          item-text="cc_nombre_area"
                          :items="areas"
                          label="Area"
                          v-model="editedItem.idArea"
                        ></v-autocomplete>
                      </v-flex>
                      <!-- 🆕 Selector de empresa -->
                      <v-flex xs12 sm12 md12>
                        <v-select
                          item-value="idEmpresa"
                          item-text="nombreEmpresa"
                          :items="[
                            { idEmpresa: 1, nombreEmpresa: 'Facilisimo' },
                            { idEmpresa: 2, nombreEmpresa: 'Apostar' }
                          ]"
                          label="Empresa"
                          v-model="editedItem.idEmpresa"
                          required
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-select
                          item-value="idNivel"
                          item-text="nivel"
                          :items="nivel"
                          label="Nivel"
                          v-model="editedItem.idNivel"
                        ></v-select>
                      </v-flex>
                      <v-flex xs4 sm4 md4>
                        <v-text-field
                          v-model="editedItem.dias"
                          label="Dias"
                          type="number"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs4 sm4 md4>
                        <v-text-field
                          v-model="editedItem.horas"
                          label="Horas"
                          type="number"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs4 sm4 md4>
                        <v-text-field
                          v-model="editedItem.minutos"
                          label="Minutos"
                          type="number"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <!-- botones para cancelar y agregregar y validacion de campos vacios -->
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#1D3C7F" dark @click="close">Cancelar</v-btn>
                  <v-btn
                    color="#1D3C7F"
                    @click="save"
                    dark 
                    :disabled="
                      !editedItem.nombre ||
                      !editedItem.idArea ||
                      !editedItem.idEmpresa ||
                      !editedItem.idNivel ||
                      (editedItem.idEmpresa == 2 && (!editedItem.dias || !editedItem.horas || !editedItem.minutos))
                    "
                    >Guardar</v-btn
                  >
                </v-card-actions>
                <!-- <pre>{{editedItem}}</pre>  -->
              </v-card>
            </v-dialog>
          </v-toolbar>
          <br />
          <!-- 🆕 Filtro por empresa -->
          <v-flex xs12 sm12 md12 class="mb-3 px-3">
            <v-select
              v-model="filtroEmpresa"
              :items="opcionesEmpresa"
              item-text="text"
              item-value="value"
              label="Filtrar por empresa"
              outlined
              dense
              style="max-width: 200px;"
            ></v-select>
          </v-flex>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar Requerimiento"
            single-line
            class="text-field"
            color="#111c3d"
          ></v-text-field>
          <br />
          <v-data-table
            :headers="headers"
            :items="requerimientosFiltrados"
            :search="search"
            style="border: 2px solid #111c3d"
            class="elevation-3"
          >
            <!-- tabla donde se pintan los datos obtenidos del arreglo -->
            <template v-slot:item.cc_prioridad_requerimiento="{ item }">
              <v-chip class="ma-2" :color="item.color">
                {{ item.cc_prioridad_requerimiento }}
              </v-chip>
            </template>
            <template v-slot:item.edit="{ item }">
              <v-icon
                class="me-3"
                color="blue"
                @click="actualizarRequerimiento(item)"
                >mdi-file-edit-outline</v-icon
              >
            </template>
            <template v-slot:no-data>
              <v-alert :value="true" color="#111c3d" icon="mdi-alert" outlined
                >No se encontro su busqueda</v-alert
              >
            </template>
          </v-data-table>
          <!-- alertas de las acciones que se hacen -->
          <v-snackbar
            v-model="snackbar"
            :bottom="y === 'bottom'"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :right="x === 'right'"
            :timeout="timeout"
            :top="y === 'top'"
            :vertical="mode === 'vertical'"
            color="#3945d0"
            style="color: white"
          >
            {{ text }}
            <v-btn color="#3945d0" depressed @click="snackbar = false"
              >Cerrar</v-btn
            >
          </v-snackbar>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import env from "../../env";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      prioridades: [
        { name: "Bajo", id: 1 },
        { name: "Medio", id: 2 },
        { name: "Alto", id: 3 },
      ],
      dialogActualizar: false,
      itemToEdit: {},
      show: false,
      snackbar: false,
      y: "top",
      x: null,
      mode: "",
      color: "",
      timeout: 6000,
      text: "",
      search: "",
      requerimientos: [],
      areas: [],
      // 🆕 Filtro por empresa
      filtroEmpresa: 'todos',
      opcionesEmpresa: [
        { text: 'Todos', value: 'todos' },
        { text: 'Apostar', value: 'apostar' },
        { text: 'Facilisimo', value: 'facilisimo' }
      ],
      nivel: [
        {
          idNivel: "1",
          nivel: "Bajo",
        },
        {
          idNivel: "2",
          nivel: "Medio",
        },
        {
          idNivel: "3",
          nivel: "Alto",
        },
      ],
      dialog: false,
      headers: [
        {
          text: "ID",
          value: "cc_id_requerimientos",
          align: "center",
        },
        {
          text: "Requerimiento",
          value: "cc_nombre_requerimiento",
          align: "center",
        },
        {
          text: "Nombre Area",
          value: "cc_nombre_area",
          align: "center",
        },
        {
          text: "Prioridad",
          value: "cc_prioridad_requerimiento",
          align: "center",
        },
        {
          text: "Empresa",
          value: "nombreEmpresa",
          align: "center",
        },
        {
          text: "Editar",
          value: "edit",
          align: "center",
        },
      ],
      defaultItem: {
        idArea: "",
        nombre: "",
        idNivel: "",
        idEmpresa: "", // 🆕 Agregar
        /* fechaI:"",
        fechaN:"", */
      },
      editedIndex: -1,
      editedItem: {
        idArea: "",
        nombre: "",
        idNivel: "",
        idEmpresa: "", // 🆕 Agregar
        /* fechaI:"",
        fechaN:"", */
      },
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Nuevo Requerimiento"
        : "Editar Requerimiento";
    },
    // 🆕 Filtro de requerimientos por empresa
    requerimientosFiltrados() {
      if (this.filtroEmpresa === 'todos') {
        return this.requerimientos;
      }
      return this.requerimientos.filter(req => {
        if (this.filtroEmpresa === 'apostar') {
          return req.idEmpresa === 2 || req.nombreEmpresa === 'Apostar';
        } else if (this.filtroEmpresa === 'facilisimo') {
          return req.idEmpresa === 1 || req.nombreEmpresa === 'Facilisimo';
        }
        return true;
      });
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  mounted() {
    this.obtenerTodo();
  },

  methods: {
    closeDialogActualizar() {
      this.dialogActualizar = false;
      this.itemToEdit = {};
    },
    handleUpdate() {
  this.dialogActualizar = false;
  Swal.fire({
    title: "¿Esta seguro que desea actualizar este requerimiento?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Sí",
    cancelButtonText: "No",
    reverseButtons: true,
  }).then((result) => {
    if (result.isConfirmed) {
      const {
        cc_prioridad_requerimiento,
        cc_nombre_requerimiento,
        cc_id_requerimientos,
        dias,
        horas,
        minutos,
        idEmpresa,  // ✅ Este campo viene del item
      } = this.itemToEdit;

      let numPrioridad =
        cc_prioridad_requerimiento === "Alto"
          ? 3
          : cc_prioridad_requerimiento === "Medio"
          ? 2
          : cc_prioridad_requerimiento === "Bajo"
          ? 1
          : null;

      const formUpdate = new FormData();
      formUpdate.append("nombreReq", cc_nombre_requerimiento);
      formUpdate.append("prioridadReq", numPrioridad);
      formUpdate.append("id", cc_id_requerimientos);
      formUpdate.append("idEmpresa", idEmpresa); // ✅ ENVIAR idEmpresa
      formUpdate.append("dias", dias);
      formUpdate.append("horas", horas);
      formUpdate.append("minutos", minutos);

      axios
        .post(`${env.endpoint}callcenter/editRequerimientos`, formUpdate)
        .then(async (resp) => {
          if (resp.data.estado) {
            this.requerimientos = [];
            this.dialogActualizar = false;
            await this.obtenerTodo();
            Swal.fire(
              "¡Requerimiento actualizado!",
              `El requerimiento ${this.itemToEdit.cc_nombre_requerimiento} ha sido actualizado`,
              "success"
            );
            this.itemToEdit = {};
          }
        })
        .catch((error) => console.log(error.response));
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      Swal.fire(
        "¡CANCELADO!",
        "Los cambios han sido descartados",
        "error"
      );
    }
  });
},
    actualizarRequerimiento(item) {
  console.log('Item recibido para editar:', item);
  console.log('Empresa:', item.idEmpresa); // ✅ Verificar que tenga idEmpresa
  this.itemToEdit = { ...item };
  this.dialogActualizar = true;
  },
    Colornivel(cc_prioridad_requerimiento) {
      return cc_prioridad_requerimient === "Bajo"
        ? "Nuevo Requerimiento"
        : "Editar Requerimiento";
    },
    /**
     * Metodo para obtener todo
     */
    async obtenerTodo() {
      // 🆕 No enviar idUsuario para que retorne requerimientos de ambas empresas
      axios.get(`${env.endpoint}callcenter/requerimientostodos`).then((res) => {
        for (let index = 0; index < res.data.length; index++) {
          if (res.data[index].cc_prioridad_requerimiento == "1") {
            res.data[index].cc_prioridad_requerimiento = "Bajo";
            res.data[index].color = "green";
          } else {
            if (res.data[index].cc_prioridad_requerimiento == "2") {
              res.data[index].cc_prioridad_requerimiento = "Medio";
              res.data[index].color = "yellow";
            } else {
              if (res.data[index].cc_prioridad_requerimiento == "3") {
                res.data[index].cc_prioridad_requerimiento = "Alto";
                res.data[index].color = "red";
              }
            }
          }
        }
        this.requerimientos = res.data;
      });
      axios
        .get(`${env.endpoint}callcenter/areastodos`)
        .then((res) => (this.areas = res.data));
    },

    /**
     * Metodo para agregar fila de la tabla en la modal
     */
    editItem(item) {
      this.editedIndex = this.usuarios.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    /**
     * Metodo para cerrar la modal
     */
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    /**
     * Metodo para guardar y actualizar
     */
    save() {
      // Validar que si es Apostar, los campos de tiempo sean obligatorios
      if (this.editedItem.idEmpresa == 2) {
        if (!this.editedItem.dias || !this.editedItem.horas || !this.editedItem.minutos) {
          this.snackbar = true;
          this.text = "Para Apostar, los campos de días, horas y minutos son obligatorios";
          return;
        }
      }
      
      // obtiene los datos del arreglo para despues setearlos en una variable nuevoUsuario y pasarselo al metodo
      const nuevoRequerimiento = JSON.stringify({
        nombre: this.editedItem.nombre,
        idNivel: this.editedItem.idNivel,
        idArea: this.editedItem.idArea,
        idEmpresa: this.editedItem.idEmpresa,
        dias: this.editedItem.dias || 0, // Si es Facilisimo, enviar 0 o null
        horas: this.editedItem.horas || 0,
        minutos: this.editedItem.minutos || 0,
      });
      // se crea la area
      axios
        .get(
          `${env.endpoint}callcenter/create_requerimiento?requerimiento=${nuevoRequerimiento}`
        )
        .then((res) => {
          if (res.data.mensaje === "requerimiento registrado") {
            (this.snackbar = true),
              (this.text = "Requerimiento registrado satisfactoriamente");
          } else if (res.data.mensaje === "error en el registro") {
            (this.snackbar = true), (this.text = "Error al registrar");
          } else if (res.data.mensaje === "error usuario existe") {
            (this.snackbar = true),
              (this.text = "El usuario ya existe en la plataforma");
          }
          // console.log(nuevoUsuario);
        });
      this.close(), this.obtenerTodo();
    },
  },
};
</script>
